<div class="card-container">
  <div class="custom-card">
    <div class="icon">
      <mat-icon class="icon-display">error</mat-icon>
    </div>

    <div class="text-big">We couldn't process<br>your payment.</div>
    <div class="text-small">
      Please change your payment method or try again.
    </div>

    <button mat-raised-button color="primary" (click)="backToShoppingCart()">Back to Shopping Cart</button>

  </div>
</div>
